module.exports = __webpack_public_path__ + "img/z2.058e7ab8.png";